class FoodCategories extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.querySelectorAll('[data-category-filter]').forEach((filter) => {
      filter.addEventListener('click', this.#handleFilterClick, { signal });
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleFilterClick = (event) => {
    const filter = event.currentTarget;
    const category = filter.dataset.categoryFilter;

    this.querySelectorAll('[data-category-filter]').forEach((f) => {
      const isActive = f === filter;
      f.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      f.classList.toggle('is-active', isActive);
    });

    filter.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

    this.querySelectorAll('[data-category-row]').forEach((row) => {
      const matches = row.dataset.categoryRow === category;
      if (matches) {
        row.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', '');
        const details = row.querySelector('details');
        if (details) details.open = false;
      }
    });
  };
}

if (!customElements.get('food-categories')) {
  customElements.define('food-categories', FoodCategories);
}
